(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rv-age-gate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rv-age-gate')) {
    customElements.define('rv-age-gate', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        const dialog = this.querySelector('dialog');
        const enter = this.querySelector('.rv-age-gate__enter');
        if (!dialog || !enter) return;
        this.dataset.ready = 'true';
        let confirmed = false;
        try {
          confirmed = sessionStorage.getItem('rv-age-confirmed-v1') === 'true';
        } catch {}
        dialog.close();
        if (confirmed) {
          this.hidden = true;
          return;
        }
        dialog.addEventListener('cancel', (event) => event.preventDefault());
        enter.addEventListener('click', () => {
          try {
            sessionStorage.setItem('rv-age-confirmed-v1', 'true');
          } catch {}
          dialog.close();
          this.hidden = true;
          document.documentElement.classList.remove('rv-age-locked');
          document.getElementById('MainContent')?.focus({ preventScroll:true });
        });
        enter.disabled = false;
        document.documentElement.classList.add('rv-age-locked');
        dialog.showModal();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
